import { Component, effect, input, output, signal } from '@angular/core';
import { RidChevron } from '../rid-chevron/rid-chevron';
import { RidWordMatrix } from '../rid-word-matrix/rid-word-matrix';
import { TRidWord } from '../rid-word/rid-word';

@Component({
  selector: 'rid-word-matrices',
  imports: [RidWordMatrix, RidChevron],
  templateUrl: './rid-word-matrices.html',
  host: {
    class: 'block w-full',
  },
})
export class RidWordMatrices {
  matrices = input.required<(string | TRidWord)[][][]>();

  index = signal(0);

  selectionChanged = output<{ kind: 'ADDED' | 'REMOVED'; index: [matrix: number, col: number, row: number] }>();
  navigated = output<number>();

  constructor() {
    effect(() => this.navigated.emit(this.index()));
  }
}
